import { type CardholderAccountDetailsApiModel } from '@webapp/modules/spending-cards/data-access/api-models/CardholderAccountDetailsApiModel'
import { type CardholderAccountDetailsConstructor } from '@webapp/modules/spending-cards/entities/CardholderAccountDetails'

export const mapCardholderAccountDetailsApiModel = (
  cardholder: CardholderAccountDetailsApiModel
): CardholderAccountDetailsConstructor => ({
  dateOfBirth: cardholder.date_of_birth,
  email: cardholder.cardholder_email,
  firstName: cardholder.legal_first_name,
  id: cardholder.id,
  lastName: cardholder.legal_last_name,
  phoneNumber: cardholder.mobile_number,
  status: cardholder.status,
  uuid: cardholder.uuid,
})
